export default __webpack_public_path__ + "static/media/035-whistle.1c36731a.png";